import React, { FC, Fragment } from "react";
import classNames from "classnames";
import { Trans } from "react-i18next";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Hidden from "@material-ui/core/Hidden";

import { makeStyles, Theme } from "@material-ui/core/styles";

import i18n from "i18n";

import HeaderButton from "./HeaderButton";
import Menu from "./Menu";
import Flag from "./Flag";
import { commonStyles } from "theme/common";

const useStyles = makeStyles((theme: Theme) => {
  return {
    button: {
      marginRight: theme.spacing(1),
    },
    menuItem: {
      color: theme.palette.primary.light,
    },
    ...commonStyles(theme),
  };
});

interface LanguageMenuProps {
  noMargin?: boolean;
}

const LanguageMenu: FC<LanguageMenuProps> = ({ noMargin }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState<string>(i18n.language.split("-")[0]);

  const handleChange = async (lang: string) => {
    await i18n.changeLanguage(lang);
    setValue(lang);
  };

  return (
    <Menu
      keepMounted
      items={[
        <MenuItem key="en" onClick={() => handleChange("en")}>
          <Box className={classes.mr1}>
            <Flag language="en" />
          </Box>
          <Trans i18nKey="LANGUAGES.EN" />
        </MenuItem>,
        <MenuItem key="hu" onClick={() => handleChange("hu")}>
          <Box className={classes.mr1}>
            <Flag language="hu" />
          </Box>
          <Trans i18nKey="LANGUAGES.HU" />
        </MenuItem>,
      ]}
    >
      {({ onClick }) => (
        <HeaderButton
          onClick={onClick}
          className={classNames({ [classes.button]: !noMargin })}
        >
          <Fragment>
            <Box className={classes.mr1} display="flex" alignItems="center">
              <Flag language={value} />
            </Box>
            <Hidden smDown>
              <Box className={classes.mr1}>
                <Typography variant="body2">{value}</Typography>
              </Box>
            </Hidden>
          </Fragment>
        </HeaderButton>
      )}
    </Menu>
  );
};

export default LanguageMenu;
